import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import type { AiNoticeKind } from './ai-notice-kind.type';

const AI_NOTICE_TEXT: Record<AiNoticeKind, string> = {
  generated: 'AI-generated. Check important facts.',
  assistant:
    'You are talking to an AI assistant. Its answers are AI-generated and can be wrong.',
  disclaimer:
    'This assistant uses AI and can make mistakes. Check important information.',
};

@Component({
  selector: 'procure-ai-notice',
  templateUrl: './ai-notice.component.html',
  styleUrl: './ai-notice.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiNotice {
  readonly kind = input<AiNoticeKind>('generated');

  protected readonly text = computed(() => AI_NOTICE_TEXT[this.kind()]);
}
